import { Suspense, lazy } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import Loading from '../Components/Layers/Loading'
import { MapStyleProvider } from '../Contexts/MapStyleContext'
import { ThemeProvider } from '../Contexts/ThemeContext'

const SharedMapViewer = lazy(
  () => import('../Components/ShareViewer/SharedMapViewer'),
)
const SharedModel3dViewer = lazy(
  () => import('../Components/ShareViewer/SharedModel3dViewer'),
)

const PublicShareApp = () => (
  <ThemeProvider>
    <MapStyleProvider>
      <BrowserRouter>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/share/:token" element={<SharedMapViewer />} />
            <Route
              path="/share/:token/viewer3d/:layerId"
              element={<SharedModel3dViewer />}
            />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </MapStyleProvider>
  </ThemeProvider>
)

export default PublicShareApp
